// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AboutRouteRouteImport } from './routes/about/route'
import { Route as ContentRouteRouteImport } from './routes/_content/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SitemapIndexRouteImport } from './routes/sitemap/index'
import { Route as PricingIndexRouteImport } from './routes/pricing/index'
import { Route as AboutIndexRouteImport } from './routes/about/index'
import { Route as FeaturesTrailsIndexRouteImport } from './routes/features/trails/index'
import { Route as FeaturesSessionsIndexRouteImport } from './routes/features/sessions/index'
import { Route as FeaturesPluginsIndexRouteImport } from './routes/features/plugins/index'
import { Route as FeaturesCodeHostingIndexRouteImport } from './routes/features/code-hosting/index'
import { Route as FeaturesCliIndexRouteImport } from './routes/features/cli/index'
import { Route as FeaturesTrailsDemoRouteImport } from './routes/features/trails/demo'
import { Route as AboutVisionIndexRouteImport } from './routes/about/vision/index'
import { Route as AboutProjectsIndexRouteImport } from './routes/about/projects/index'
import { Route as AboutIndiaIndexRouteImport } from './routes/about/india/index'
import { Route as AboutCompanyIndexRouteImport } from './routes/about/company/index'
import { Route as AboutCliIndexRouteImport } from './routes/about/cli/index'
import { Route as ContentTermsIndexRouteImport } from './routes/_content/terms/index'
import { Route as ContentSubprocessorsIndexRouteImport } from './routes/_content/subprocessors/index'
import { Route as ContentRegionsIndexRouteImport } from './routes/_content/regions/index'
import { Route as ContentRebellionIndexRouteImport } from './routes/_content/rebellion/index'
import { Route as ContentPrivacyIndexRouteImport } from './routes/_content/privacy/index'
import { Route as ContentNewsIndexRouteImport } from './routes/_content/news/index'
import { Route as ContentDpaIndexRouteImport } from './routes/_content/dpa/index'
import { Route as ContentCreditTermsIndexRouteImport } from './routes/_content/credit-terms/index'
import { Route as ContentCookiesIndexRouteImport } from './routes/_content/cookies/index'
import { Route as ContentBrandIndexRouteImport } from './routes/_content/brand/index'
import { Route as ContentBlogIndexRouteImport } from './routes/_content/blog/index'
import { Route as ContentTermsDateRouteImport } from './routes/_content/terms/$date'
import { Route as ContentSubprocessorsDateRouteImport } from './routes/_content/subprocessors/$date'
import { Route as ContentRegionsDateRouteImport } from './routes/_content/regions/$date'
import { Route as ContentRebellionThanksRouteImport } from './routes/_content/rebellion/thanks'
import { Route as ContentPrivacyDateRouteImport } from './routes/_content/privacy/$date'
import { Route as ContentNewsPodcastsRouteImport } from './routes/_content/news/podcasts'
import { Route as ContentNewsArticlesRouteImport } from './routes/_content/news/articles'
import { Route as ContentNewsSlugRouteImport } from './routes/_content/news/$slug'
import { Route as ContentDpaDateRouteImport } from './routes/_content/dpa/$date'
import { Route as ContentCreditTermsDateRouteImport } from './routes/_content/credit-terms/$date'
import { Route as ContentCookiesDateRouteImport } from './routes/_content/cookies/$date'
import { Route as ContentBlogSlugRouteImport } from './routes/_content/blog/$slug'
import { Route as ContentBlogAuthorsSlugRouteImport } from './routes/_content/blog/authors/$slug'

const AboutRouteRoute = AboutRouteRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const ContentRouteRoute = ContentRouteRouteImport.update({
            id: '/_content',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SitemapIndexRoute = SitemapIndexRouteImport.update({
            id: '/sitemap/',path: '/sitemap/',getParentRoute: () => rootRouteImport
          })
const PricingIndexRoute = PricingIndexRouteImport.update({
            id: '/pricing/',path: '/pricing/',getParentRoute: () => rootRouteImport
          })
const AboutIndexRoute = AboutIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AboutRouteRoute
          })
const FeaturesTrailsIndexRoute = FeaturesTrailsIndexRouteImport.update({
            id: '/features/trails/',path: '/features/trails/',getParentRoute: () => rootRouteImport
          })
const FeaturesSessionsIndexRoute = FeaturesSessionsIndexRouteImport.update({
            id: '/features/sessions/',path: '/features/sessions/',getParentRoute: () => rootRouteImport
          })
const FeaturesPluginsIndexRoute = FeaturesPluginsIndexRouteImport.update({
            id: '/features/plugins/',path: '/features/plugins/',getParentRoute: () => rootRouteImport
          })
const FeaturesCodeHostingIndexRoute = FeaturesCodeHostingIndexRouteImport.update({
            id: '/features/code-hosting/',path: '/features/code-hosting/',getParentRoute: () => rootRouteImport
          })
const FeaturesCliIndexRoute = FeaturesCliIndexRouteImport.update({
            id: '/features/cli/',path: '/features/cli/',getParentRoute: () => rootRouteImport
          })
const FeaturesTrailsDemoRoute = FeaturesTrailsDemoRouteImport.update({
            id: '/features/trails/demo',path: '/features/trails/demo',getParentRoute: () => rootRouteImport
          })
const AboutVisionIndexRoute = AboutVisionIndexRouteImport.update({
            id: '/vision/',path: '/vision/',getParentRoute: () => AboutRouteRoute
          })
const AboutProjectsIndexRoute = AboutProjectsIndexRouteImport.update({
            id: '/projects/',path: '/projects/',getParentRoute: () => AboutRouteRoute
          })
const AboutIndiaIndexRoute = AboutIndiaIndexRouteImport.update({
            id: '/india/',path: '/india/',getParentRoute: () => AboutRouteRoute
          })
const AboutCompanyIndexRoute = AboutCompanyIndexRouteImport.update({
            id: '/company/',path: '/company/',getParentRoute: () => AboutRouteRoute
          })
const AboutCliIndexRoute = AboutCliIndexRouteImport.update({
            id: '/cli/',path: '/cli/',getParentRoute: () => AboutRouteRoute
          })
const ContentTermsIndexRoute = ContentTermsIndexRouteImport.update({
            id: '/terms/',path: '/terms/',getParentRoute: () => ContentRouteRoute
          })
const ContentSubprocessorsIndexRoute = ContentSubprocessorsIndexRouteImport.update({
            id: '/subprocessors/',path: '/subprocessors/',getParentRoute: () => ContentRouteRoute
          })
const ContentRegionsIndexRoute = ContentRegionsIndexRouteImport.update({
            id: '/regions/',path: '/regions/',getParentRoute: () => ContentRouteRoute
          })
const ContentRebellionIndexRoute = ContentRebellionIndexRouteImport.update({
            id: '/rebellion/',path: '/rebellion/',getParentRoute: () => ContentRouteRoute
          })
const ContentPrivacyIndexRoute = ContentPrivacyIndexRouteImport.update({
            id: '/privacy/',path: '/privacy/',getParentRoute: () => ContentRouteRoute
          })
const ContentNewsIndexRoute = ContentNewsIndexRouteImport.update({
            id: '/news/',path: '/news/',getParentRoute: () => ContentRouteRoute
          })
const ContentDpaIndexRoute = ContentDpaIndexRouteImport.update({
            id: '/dpa/',path: '/dpa/',getParentRoute: () => ContentRouteRoute
          })
const ContentCreditTermsIndexRoute = ContentCreditTermsIndexRouteImport.update({
            id: '/credit-terms/',path: '/credit-terms/',getParentRoute: () => ContentRouteRoute
          })
const ContentCookiesIndexRoute = ContentCookiesIndexRouteImport.update({
            id: '/cookies/',path: '/cookies/',getParentRoute: () => ContentRouteRoute
          })
const ContentBrandIndexRoute = ContentBrandIndexRouteImport.update({
            id: '/brand/',path: '/brand/',getParentRoute: () => ContentRouteRoute
          })
const ContentBlogIndexRoute = ContentBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => ContentRouteRoute
          })
const ContentTermsDateRoute = ContentTermsDateRouteImport.update({
            id: '/terms/$date',path: '/terms/$date',getParentRoute: () => ContentRouteRoute
          })
const ContentSubprocessorsDateRoute = ContentSubprocessorsDateRouteImport.update({
            id: '/subprocessors/$date',path: '/subprocessors/$date',getParentRoute: () => ContentRouteRoute
          })
const ContentRegionsDateRoute = ContentRegionsDateRouteImport.update({
            id: '/regions/$date',path: '/regions/$date',getParentRoute: () => ContentRouteRoute
          })
const ContentRebellionThanksRoute = ContentRebellionThanksRouteImport.update({
            id: '/rebellion/thanks',path: '/rebellion/thanks',getParentRoute: () => ContentRouteRoute
          })
const ContentPrivacyDateRoute = ContentPrivacyDateRouteImport.update({
            id: '/privacy/$date',path: '/privacy/$date',getParentRoute: () => ContentRouteRoute
          })
const ContentNewsPodcastsRoute = ContentNewsPodcastsRouteImport.update({
            id: '/news/podcasts',path: '/news/podcasts',getParentRoute: () => ContentRouteRoute
          })
const ContentNewsArticlesRoute = ContentNewsArticlesRouteImport.update({
            id: '/news/articles',path: '/news/articles',getParentRoute: () => ContentRouteRoute
          })
const ContentNewsSlugRoute = ContentNewsSlugRouteImport.update({
            id: '/news/$slug',path: '/news/$slug',getParentRoute: () => ContentRouteRoute
          })
const ContentDpaDateRoute = ContentDpaDateRouteImport.update({
            id: '/dpa/$date',path: '/dpa/$date',getParentRoute: () => ContentRouteRoute
          })
const ContentCreditTermsDateRoute = ContentCreditTermsDateRouteImport.update({
            id: '/credit-terms/$date',path: '/credit-terms/$date',getParentRoute: () => ContentRouteRoute
          })
const ContentCookiesDateRoute = ContentCookiesDateRouteImport.update({
            id: '/cookies/$date',path: '/cookies/$date',getParentRoute: () => ContentRouteRoute
          })
const ContentBlogSlugRoute = ContentBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => ContentRouteRoute
          })
const ContentBlogAuthorsSlugRoute = ContentBlogAuthorsSlugRouteImport.update({
            id: '/blog/authors/$slug',path: '/blog/authors/$slug',getParentRoute: () => ContentRouteRoute
          })





const ContentRouteRouteChildren = {
  ContentBlogSlugRoute: ContentBlogSlugRoute,ContentCookiesDateRoute: ContentCookiesDateRoute,ContentCreditTermsDateRoute: ContentCreditTermsDateRoute,ContentDpaDateRoute: ContentDpaDateRoute,ContentNewsSlugRoute: ContentNewsSlugRoute,ContentNewsArticlesRoute: ContentNewsArticlesRoute,ContentNewsPodcastsRoute: ContentNewsPodcastsRoute,ContentPrivacyDateRoute: ContentPrivacyDateRoute,ContentRebellionThanksRoute: ContentRebellionThanksRoute,ContentRegionsDateRoute: ContentRegionsDateRoute,ContentSubprocessorsDateRoute: ContentSubprocessorsDateRoute,ContentTermsDateRoute: ContentTermsDateRoute,ContentBlogIndexRoute: ContentBlogIndexRoute,ContentBrandIndexRoute: ContentBrandIndexRoute,ContentCookiesIndexRoute: ContentCookiesIndexRoute,ContentCreditTermsIndexRoute: ContentCreditTermsIndexRoute,ContentDpaIndexRoute: ContentDpaIndexRoute,ContentNewsIndexRoute: ContentNewsIndexRoute,ContentPrivacyIndexRoute: ContentPrivacyIndexRoute,ContentRebellionIndexRoute: ContentRebellionIndexRoute,ContentRegionsIndexRoute: ContentRegionsIndexRoute,ContentSubprocessorsIndexRoute: ContentSubprocessorsIndexRoute,ContentTermsIndexRoute: ContentTermsIndexRoute,ContentBlogAuthorsSlugRoute: ContentBlogAuthorsSlugRoute
}

const ContentRouteRouteWithChildren = ContentRouteRoute._addFileChildren(ContentRouteRouteChildren)




const AboutRouteRouteChildren = {
  AboutIndexRoute: AboutIndexRoute,AboutCliIndexRoute: AboutCliIndexRoute,AboutCompanyIndexRoute: AboutCompanyIndexRoute,AboutIndiaIndexRoute: AboutIndiaIndexRoute,AboutProjectsIndexRoute: AboutProjectsIndexRoute,AboutVisionIndexRoute: AboutVisionIndexRoute
}

const AboutRouteRouteWithChildren = AboutRouteRoute._addFileChildren(AboutRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,ContentRouteRoute: ContentRouteRouteWithChildren,AboutRouteRoute: AboutRouteRouteWithChildren,PricingIndexRoute: PricingIndexRoute,SitemapIndexRoute: SitemapIndexRoute,FeaturesTrailsDemoRoute: FeaturesTrailsDemoRoute,FeaturesCliIndexRoute: FeaturesCliIndexRoute,FeaturesCodeHostingIndexRoute: FeaturesCodeHostingIndexRoute,FeaturesPluginsIndexRoute: FeaturesPluginsIndexRoute,FeaturesSessionsIndexRoute: FeaturesSessionsIndexRoute,FeaturesTrailsIndexRoute: FeaturesTrailsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)